import { ChevronDownIcon } from "lucide-react";
import Button from "./Button";
import React, { useEffect, useRef } from "react";

// non-select dropdown, used for selectable menus
export default function Dropdown({ buttonItem, options, direction = "left", color="black", buttonKind ="white", additionalClasses = ""}) {
const dropdownRef = useRef(null);

useEffect(() => {
  if (window.HSStaticMethods?.autoInit) {
    window.HSStaticMethods.autoInit(["dropdown"]);
  }
}, []);

const handleMenuClickCapture = (event) => {
  const closeTrigger = event.target.closest("[data-hs-dropdown-close]");
  if (!closeTrigger) return;

  const toggleButton = dropdownRef.current?.querySelector(".hs-dropdown-toggle");
  if (!toggleButton) return;

  window.setTimeout(() => {
    toggleButton.click();
  }, 0);
};

  return (
    <div
      ref={dropdownRef}
      className={`hs-dropdown relative inline-flex ${
        direction === "right" && "[--placement:bottom-right]"
      } [--auto-close:inside]`}
    >
      {/* button */}
      <Button kind={buttonKind} color={color} additionalClasses={`hs-dropdown-toggle ${additionalClasses}`} type="button">
        {buttonItem}
        <ChevronDownIcon size={16} className=" hs-dropdown-open:rotate-180" />
      </Button>
      <div
        className="
        min-w-64
        z-20
        hs-dropdown-menu transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-48 
        bg-white shadow-md rounded-lg mt-2 outline outline-1 outline-offset-[-1px] outline-border
        after:h-4 after:absolute after:-bottom-4 after:start-0 after:w-full 
        before:h-4 before:absolute before:-top-4 before:start-0 before:w-full"
      >
        <div
          onClickCapture={handleMenuClickCapture}
          className="
          p-3 space-y-2
          *:z-20
          *:flex *:items-center *:gap-2 *:py-2 *:px-3 *:rounded-lg *:w-full
          *:text-base *:text-text-primary hover:*:bg-gray-100 *:focus:outline-hidden
        "
        >
          {options.map((option, index) => <React.Fragment key={`${index}`}>{option}</React.Fragment>)}
        </div>
      </div>
    </div>
  );
}
